module.exports = __webpack_public_path__ + "static/media/header-bg.7ff48230.jpg";